import { render, staticRenderFns } from "./ItemReport.vue?vue&type=template&id=18a681ca&scoped=true"
import script from "./ItemReport.vue?vue&type=script&lang=js"
export * from "./ItemReport.vue?vue&type=script&lang=js"
import style0 from "./ItemReport.vue?vue&type=style&index=0&id=18a681ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a681ca",
  null
  
)

export default component.exports